import {useEffect} from 'react';

export default function () {
    useEffect(() => {
        document.body.classList.toggle('no-scroll');
        return () => {
            document.body.classList.toggle('no-scroll');
        }
    }, []);
}